export default "/_next/static/images/78de370d7c73b33ff742841bbccb689c.png";